(() => {
  const initFooter = (scope = document) => {
    scope.querySelectorAll('[data-petpaw-footer]').forEach((footer) => {
      if (footer.dataset.ready === 'true') return;
      footer.dataset.ready = 'true';

      footer.querySelectorAll('[data-footer-accordion]').forEach((item) => {
        const button = item.querySelector('.petpaw-footer__heading');
        if (!button) return;
        button.addEventListener('click', () => {
          if (!window.matchMedia('(max-width: 576px)').matches) return;
          const open = item.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(open));
        });
      });

      footer.querySelector('[data-footer-back-to-top]')?.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initFooter());
  document.addEventListener('shopify:section:load', (event) => initFooter(event.target));
})();
